import { BusinessForms, IBusiness } from '@query'
import { VatPeriod } from '@root/constants'
import React, { useContext } from 'react'

interface Props {
  slug: string
  data: IBusiness
}

export const BusinessContext = React.createContext<Props>({ slug: '', data: null })

export const useBusinessContext = (): Props => {
  return useContext(BusinessContext)
}

export const isVATObliged = (business?: IBusiness): boolean =>
  business?.default_vat_period !== VatPeriod.NONE

export const hasHistoryBeforeNoCFO = (business?: IBusiness): boolean =>
  Boolean(business?.has_history_before_nocfo)

export const isNYBusiness = (business?: IBusiness): boolean =>
  business?.form === BusinessForms.FI_NY

export const isBillableBusiness = (business?: IBusiness): boolean => Boolean(business?.is_billable)
